export default "__VITE_ASSET__064ce6ae__"